// extracted by mini-css-extract-plugin
export default {"introImgs":"Blog_introImgs__+Riai","blogHeading":"Blog_blogHeading__lUpiC","gridContainer":"Blog_gridContainer__BSMaM"};